import { render } from "./DetailsInput.vue?vue&type=template&id=bb12a67a&scoped=true"
import script from "./DetailsInput.vue?vue&type=script&lang=js"
export * from "./DetailsInput.vue?vue&type=script&lang=js"

import "./DetailsInput.vue?vue&type=style&index=0&id=bb12a67a&lang=css&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb12a67a"]])

export default __exports__